import React, { useEffect, useCallback, useState} from 'react';
import Documented from "components/help/Documented.js";
import {
    PADS_DELETE_BUTTON,
    PADS_WAVEFORM_BUTTON,
    PADS_MUTES_BUTTON,
    PADS_EXPAND_BUTTON
} from "constants/contextual-help.js";
import PadLength from './PadLength.js';
import {connect} from 'react-redux';
import {WAVEFORM ,DELETE, MUTES} from './modes.js';

const PadToolbar = ({
    pad,
    setMode,
    mode
}) => { 
    const showWaveform = useCallback((e) => {
        if (mode === WAVEFORM) {
            setMode(undefined);
        } else {
            setMode(WAVEFORM);
        }
    }, [mode, setMode]);

    return (
        <div className="pad-toolbar">
          <ModeBtn element={PADS_DELETE_BUTTON} mode={mode} setMode={setMode} option={DELETE} name="Delete"/>
          <ModeBtn element={PADS_MUTES_BUTTON} mode={mode} setMode={setMode} option={MUTES} name="Mutes"/>
          <Documented
            element={PADS_WAVEFORM_BUTTON}
            onClick={showWaveform}
            className={mode === WAVEFORM ? "waveform-btn selected" : "waveform-btn"}>
            <div className="wave"/>
            <div className="wave"/>
          </Documented>
          <PadLength pad={pad}/>
        </div>
    );
};

const ModeBtn = ({element, option, name, mode, setMode}) => {
    let className = "pad-toolbar-btn";
    if (option === mode) {
        className += " selected";
    }
    return (
        <Documented
          element={element}
          onClick={() => setMode(option === mode ? undefined : option)}
          className={className}>
          {name}
        </Documented>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PadToolbar);
